import {Component, HostListener, Inject, PLATFORM_ID, ViewEncapsulation} from '@angular/core';
import {CommonConstants, ImageSizeConstants, RoutesConstants} from '@coreconstant';
import {BlogService} from '../core/services/api-service/blog.service';
import {ResponseHandlerService} from '../core/services/common-service/response-handler.service';
import {lastValueFrom} from 'rxjs';
import {ImagePathConstants} from '../core/constants/image-path-constants';
import {isPlatformBrowser} from '@angular/common';
import {RouterModule} from '@angular/router';
import {SeoService} from '../core/services/common-service/seo.service';
import {RequestParamModel} from '../core/models/request-param-model';
import {MetaDataConstants} from '../core/constants/meta-data-constants';

@Component({
    selector: 'app-home',
    imports: [RouterModule],
    templateUrl: './home.component.html',
    styleUrl: './home.component.scss',
    encapsulation: ViewEncapsulation.None
})
export class HomeComponent {
    routesConstants = RoutesConstants
    commonConstants = CommonConstants
    imagePathConstants = ImagePathConstants
    imageSizeConstants = ImageSizeConstants
    trendingBlogs = [];
    isMobileView: boolean = false
    requestParamModel: RequestParamModel;
    blogTags: any = this.commonConstants.BLOG_TAGS_HOMEPAGE;

    @HostListener('window:resize', [])
    onWindowResize() {
        if (isPlatformBrowser(this.platformId)) {
            this.isMobileView = window.innerWidth < 768;
        }
    }

    constructor(
        @Inject(PLATFORM_ID) private platformId: Object,
        private _blogService: BlogService,
        private _responseHandlerService: ResponseHandlerService,
        private _seoService: SeoService,
    ) {
        this.onWindowResize()
        this.setMetaTags()
    }

    /**
     * Initializes the component and its dependent processes.
     */
    ngOnInit() {
        this.getTrendingBlogs()
    }

    /**
     * Sets the meta tags for the current page by creating a meta tag object and passes it to the SEO service for application.
     * @return {void} Does not return a value.
     */
    setMetaTags() {
        let metaTagObject = {
            title: MetaDataConstants.HOME.TITLE,
            description: MetaDataConstants.HOME.DESCRIPTION,
            ogImageUrl: MetaDataConstants.HOME.OGIMAGEURL,
            ogWebUrl: this.routesConstants.HOME_NAVIGATION,
        }
        this._seoService.setMetaTags(metaTagObject)
    }

    /**
     * Scrolls smoothly to the specified section of the page based on the section ID and adjusts for header offset.
     * @param {string} sectionId - The ID of the section to scroll to.
     */
    scrollToSection(sectionId: any) {
        const element = document.getElementById(sectionId);
        if (element) {
            element.scrollIntoView({behavior: 'smooth', block: 'center'});
        }
    }

    /**
     * Fetches the list of trending blogs based on the predefined filter criteria.
     */
    getTrendingBlogs() {
        let requestModel = new RequestParamModel();
        requestModel.setFilter("isTrending", 1);
        requestModel.pageSize = 4
        let getListing = this._blogService.getBlogsList(requestModel)
        lastValueFrom(getListing).then((res: any) => {
            if (res["data"]) {
                this.trendingBlogs = res["data"];
            } else {
                this._responseHandlerService.showErrorMessageGeneral(res["message"] ?? this.commonConstants.SOMETHING_WENT_WRONG)

            }
        }, (error: any) => {
            this._responseHandlerService.handleAPIErrorResponse(error)
        });
    }

    /**
     * Sets the default image for an HTMLImageElement when an error occurs
     * @param {Event} event - The event object associated with the image load error.
     */
    setDefaultImage(event: Event) {
        let image = this.commonConstants.DEFAULT_NO_IMAGE;
        (event.target as HTMLImageElement).src = image
    }
}
